import * as React from 'react'
import * as pbi from 'powerbi-client';
import { Component } from 'react';

declare var powerbi: pbi.service.Service;


export class Dashboard extends React.Component<any, any> {
    component: pbi.Embed;
    rootElement: HTMLDivElement;

    constructor(props) {
        super(props);
        this.component = null;
        this.state = {
            type: 'report'
        };
    }

    componentDidMount() {
        this.updateState(this.props);
    }

    
    componentDidUpdate(prevProps) {
        if (prevProps != this.props) {
            this.updateState(this.props);
        }
        
    }

    componentWillUnmount() {
        this.reset();
    }

    embed(config) {
        this.reset();
        this.component = powerbi.embed(this.rootElement, config);
      //  var report: pbi.Report = this.component as pbi.Report;

        //report.on('loaded', function (event) {
        //    report.getPages().then(function (pages) {
        //        var page = pages[1];
        //        page.getVisuals()
        //            .then(function (visuals) {
        //                var visual = visuals[0];
        //            });
        //    });
        //});

    
        if (this.props.onEmbedded) {
            this.props.onEmbedded(this.component);
        }
        return this.component;
    }

    reset() {
        powerbi.reset(this.rootElement);
        this.component = null;
    }

    updateState(props) {
        const nextState = Object.assign({}, this.state, props, {
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true
            }
        });
        /**
         * This property must be removed from the state object so that it doesn't get used in the embedConfig.
         * This would be passed to `powerbi.embed(element, embedConfig)` and attempted to be sent over postMessage;
         * however, functions cannot be cloned and it will fail.
         */
        delete nextState.onEmbedded;
        this.setState(nextState, () => {
            if (this.validateConfig(this.state)) {
                return this.embed(this.state);
            }});
    }

    validateConfig(config) {
        const errors = pbi.models.validateReportLoad(config);
        return (errors === undefined);
    }

    render() {
        return (
            <div className='powerbi-frame' ref={(ref) => this.rootElement = ref}></div>
        )
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/powerBIComponents/Dashboard.tsx